<template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0604'" style="margin: 0 auto; width: 100%; margin-top: 10px">
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>补光记录</h3>
          </div>
          <div class="table-title-btn">
            <el-button type="primary" class="adduser" @click="handleReturn">返回决策模型</el-button>
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="阶段时间名称">
              <template slot-scope="scope">
                <p>{{ scope.row.modelTimeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="光合作用名称">
              <template slot-scope="scope">
                <p>{{ scope.row.planName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="累计完成时间（分钟）">
              <template slot-scope="scope">
                <p>{{ scope.row.finishTime }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 0">禁用</p>
                <p v-if="scope.row.status == 1">启用</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status == 0" type="text" size="small"
                  @click="handleStatus(scope.row)">启用</el-button>
                <el-button v-if="scope.row.status == 1" type="text" size="small"
                  @click="handleStatus(scope.row)">禁用</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap"
              @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize"
              :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        decisionId: "",
      },
      total: 0, // 总数
      tableData: [],
      loading: false,
    };
  },
  created() {
    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        decisionId: "",
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.searchForm.decisionId = this.$route.query.decisionId;
      this.$api.photosynthesis.getNewGroupPlanList(this.searchForm).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.count;
        }
      });
    },
    // 启用、禁用
    handleStatus(row) {
      this.$api.photosynthesis.noOrOffGroupPlan({ id: row.id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.handleSearch();
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>